import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Grid } from "@mui/system";

import style from "../../../assets/css/proposal.module.scss";

import GlobalTextField from "../../global-fields/GlobalTextField";

const ShippingLocationAccordion = ({
  title,
  prefix = "",
  formik,
  handleAmountFieldChange,
  index
 
}) => {

  const field = (name) => (prefix ? `${prefix}.${name}` : name);

  const getValue = (name) => {
    if (!prefix) return formik.values[name];

    return formik.values.additional_locations?.[
      Number(prefix.split(".")[1])
    ]?.[name];
  };

  const getError = (name) => {
    if (!prefix) {
      return (
        formik.touched?.[name] &&
        Boolean(formik.errors?.[name])
      );
    }

    const index = Number(prefix.split(".")[1]);

    return (
      formik.touched?.additional_locations?.[index]?.[name] &&
      Boolean(formik.errors?.additional_locations?.[index]?.[name])
    );
  };

  const getHelper = (name) => {
    if (!prefix) {
      return (
        formik.touched?.[name] &&
        formik.errors?.[name]
      );
    }

    const index = Number(prefix.split(".")[1]);

    return (
      formik.touched?.additional_locations?.[index]?.[name] &&
      formik.errors?.additional_locations?.[index]?.[name]
    );
  };

  const renderField = (label, name) => (
    <Grid size={{ xs: 12, xl: 2, lg: 4, sm: 4 }}>
      <Box sx={{ mb: 1 }}>
        <h3 className={style.htitleText}>{label}</h3>
      </Box>

      <GlobalTextField
        placeH="$"
        type="text"
        name={field(name)}
        value={getValue(name)}
        onChange={(e) =>
          handleAmountFieldChange(e, field(name))
        }
        onBlur={formik.handleBlur}
        error={getError(name)}
        helperText={getHelper(name)}
      />
    </Grid>
  );

  return (
    <Accordion
      defaultExpanded
      sx={{
        mb: 2,
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "none",
        border: "1px solid #d9e2ec",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: "#f5f9fc",
        }}
      >
        <Typography
          sx={{
            color: "#0b5c7c",
            fontWeight: 600,
          }}
        >
          Location{index +1}- {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>

        {/* Question 15 */}

        <Grid container spacing={2}>

          <Grid size={{ xs: 12 }}>
            <h2 className={style.formTitleh2}>
              15) What limits do you desire for section 2 of the policy?
            </h2>
          </Grid>

          {renderField(
            "Registered Mail *",
            "registered_mail_under_section2"
          )}

          {renderField(
            "Armored Car Service *",
            "armed_car_service_under_section2"
          )}

          {renderField(
            "Airfreight *",
            "airfreight_under_section2"
          )}

          {renderField(
            "Fed Exp/UPS or Similar *",
            "fed_exp_ups_under_section2"
          )}

          {renderField(
            "USPS Express Mail *",
            "usps_express_mail_under_section2"
          )}

          {renderField(
            "Secure Overnight *",
            "secure_overnight_under_section2"
          )}

        </Grid>

        {/* Question 16 */}

        <Grid container spacing={2} sx={{ mt: 3 }}>

          <Grid size={{ xs: 12 }}>
            <h2 className={style.formTitleh2}>
              16) Property Outside of our Premises
            </h2>

            <Typography className={style.htitleText}>
              Within USA and/or Canada
            </Typography>
          </Grid>

          {renderField(
            "Registered Mail *",
            "registered_mail_within_usa_canada"
          )}

          {renderField(
            "Armored Car Service *",
            "armed_car_within_usa_canada"
          )}

          {renderField(
            "Airfreight *",
            "airfreight_within_usa_canada"
          )}

          {renderField(
            "Fed Exp/UPS or Similar *",
            "fed_exp_ups_within_usa_canada"
          )}

          {renderField(
            "USPS Express Mail *",
            "usps_express_mail_within_usa_canada"
          )}

          {renderField(
            "Secure Overnight *",
            "secure_overnight_within_usa_canada"
          )}

        </Grid>

        <Grid container spacing={2} sx={{ mt: 3 }}>

          <Grid size={{ xs: 12 }}>
            <Typography className={style.htitleText}>
              Elsewhere
            </Typography>
          </Grid>

          {renderField(
            "Registered Mail *",
            "registered_mail_elsewhere"
          )}

          {renderField(
            "Armored Car Service *",
            "armed_car_elsewhere"
          )}

          {renderField(
            "Airfreight *",
            "airfreight_elsewhere"
          )}

          {renderField(
            "Fed Exp/UPS or Similar *",
            "fed_exp_ups_elsewhere"
          )}

          {renderField(
            "USPS Express Mail *",
            "usps_express_mail_elsewhere"
          )}

          {renderField(
            "Secure Overnight *",
            "secure_overnight_elsewhere"
          )}

        </Grid>

      </AccordionDetails>
    </Accordion>
  );
};

export default ShippingLocationAccordion;